module.exports = __webpack_public_path__ + "img/cisco_network_academy_app.183b0bbe.jpg";